/* Система налогообложения */

export default class DayOfWeek {
  static get Monday () { return 1 }
  static get Tuesday () { return 2 }
  static get Wednesday () { return 3 }
  static get Thursday () { return 4 }
  static get Friday () { return 5 }
  static get Saturday () { return 6 }
  static get Sunday () { return 7 }

  static getName (enumValue) {
    switch (enumValue) {
      case DayOfWeek.Monday:
        return 'Понедельник'

      case DayOfWeek.Tuesday:
        return 'Вторник'

      case DayOfWeek.Wednesday:
        return 'Среда'

      case DayOfWeek.Thursday:
        return 'Четверг'

      case DayOfWeek.Friday:
        return 'Пятница'

      case DayOfWeek.Saturday:
        return 'Суббота'

      case DayOfWeek.Sunday:
        return 'Воскресенье'

      default:
        return enumValue
    }
  }

  static getAllVariants () {
    const variants = [
      DayOfWeek.Monday,
      DayOfWeek.Tuesday,
      DayOfWeek.Wednesday,
      DayOfWeek.Thursday,
      DayOfWeek.Friday,
      DayOfWeek.Saturday,
      DayOfWeek.Sunday,
    ]

    return variants.map(item => ({
      value: item,
      name: DayOfWeek.getName(item),
    }))
  }
}
